// Note: this module is compiled as an entrypoint by webpack in order to be able
// to place it in the head of every page instead of being compiled with the
// other global modules

// Local imports
//
import * as gtmlib from './lib.js';

// ===========================================================================
// Main
// ===========================================================================

gtmlib.main();

// ===========================================================================
//
// ===========================================================================
